import { render } from "./Gameboard_MBS.vue?vue&type=template&id=3838d4ac"
import script from "./Gameboard_MBS.vue?vue&type=script&lang=js"
export * from "./Gameboard_MBS.vue?vue&type=script&lang=js"

import "./Gameboard_MBS.vue?vue&type=style&index=0&id=3838d4ac&lang=scss"
script.render = render

export default script